var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPerformSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15234 15.5C1.81901 15.5 1.52734 15.375 1.27734 15.125C1.02734 14.875 0.902344 14.5833 0.902344 14.25V1.75C0.902344 1.41667 1.02734 1.125 1.27734 0.875C1.52734 0.625 1.81901 0.5 2.15234 0.5H12.1107C12.2835 0.5 12.4482 0.534722 12.6049 0.604167C12.7615 0.673611 12.8954 0.763889 13.0065 0.875L15.5273 3.39583C15.6385 3.50694 15.7287 3.64082 15.7982 3.79746C15.8676 3.9541 15.9023 4.11883 15.9023 4.29167V14.25C15.9023 14.5833 15.7773 14.875 15.5273 15.125C15.2773 15.375 14.9857 15.5 14.6523 15.5H2.15234ZM14.6523 4.33333L12.069 1.75H2.15234V14.25H14.6523V4.33333ZM2.15234 4.33333V14.25V1.75V4.33333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34679 10.4487C7.25017 10.5137 7.15194 10.5169 7.0521 10.4584C6.95226 10.3999 6.90234 10.3121 6.90234 10.195V5.80499C6.90234 5.68792 6.95226 5.60012 7.0521 5.54159C7.15194 5.48306 7.25017 5.48631 7.34679 5.55135L10.7671 7.75611C10.8573 7.81464 10.9023 7.89594 10.9023 8C10.9023 8.10406 10.8573 8.18536 10.7671 8.24389L7.34679 10.4487Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerformSave);
export default __webpack_public_path__ + "static/media/iconPerformSave.16483868.svg";
export { ForwardRef as ReactComponent };